import { useState } from "react";

import Popup from "../ImagePreviewPopup";

const countPagesIncludingChildren = (pages) => {
  let count = pages.length;
  pages.forEach((page) => {
    if (page.children && page.children.length > 0) {
      count += countPagesIncludingChildren(page.children);
    }
  });
  return count;
};

const getAllPages = (pages, result = []) => {
  pages.forEach((page) => {
    result.push({ id: page.id, title: page.title, url: page.url });
    if (page.children && page.children.length > 0) {
      getAllPages(page.children, result);
    }
  });
  return result;
};

const TreeNode = ({ node, userData, setUserData }) => {
  const isSelected = (userData.selectedPages || []).some(
    (page) => page.id === node.id
  );

  const [trigger, setTrigger] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);

  const handleCheckboxChange = () => {
    let updatedSelectedPages;
    if (isSelected) {
      updatedSelectedPages = (userData.selectedPages || []).filter(
        (page) => !isPageInSubtree(page, node)
      );
    } else {
      const subtreePages = getAllPages([node]);
      updatedSelectedPages = [
        ...(userData.selectedPages || []),
        ...subtreePages.filter(
          (page) =>
            !(userData.selectedPages || []).some(
              (selected) => selected.id === page.id
            )
        ),
      ];
    }
    setUserData({ ...userData, selectedPages: updatedSelectedPages });
  };

  const toggleChildren = () => {
    setIsExpanded(!isExpanded);
  };

  const isPageInSubtree = (page, subtreeRoot) => {
    if (page.id === subtreeRoot.id) {
      return true;
    }
    if (subtreeRoot.children) {
      return subtreeRoot.children.some((child) => isPageInSubtree(page, child));
    }
    return false;
  };

  const totalPageCount = countPagesIncludingChildren(userData.pages);

  return (
    <ul key={node.id}>
      <li>
        <div className="app-ai-quote-tree-body-item">
          <button
            className={`app-ai-quote-tree-body-item-btn-hide ${
              isExpanded ? "app-ai-quote-tree-body-item-btn-active" : ""
            }`}
            onClick={toggleChildren}
            style={{
              display:
                node.children && node.children.length > 0 ? "block" : "none",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 15L12 9L18 15"
                stroke="#060A23"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div>
            <input
              type="checkbox"
              checked={isSelected}
              onChange={handleCheckboxChange}
            />
            <span />
          </div>
          {node.title}{" "}
          <div className="app-ai-quote-tree-body-item-buttons">
            <button onClick={() => setTrigger(true)}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                  stroke="#506BF0"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 12C19.333 16.667 16 19 12 19C8 19 4.667 16.667 2 12C4.667 7.333 8 5 12 5C16 5 19.333 7.333 22 12Z"
                  stroke="#506BF0"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Open page preview</span>
            </button>
            <a href={node.url} target="_blank" rel="noopener noreferrer">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1129_151)">
                  <path
                    d="M10 13.9999C10.3259 14.3325 10.7148 14.5967 11.1441 14.7771C11.5734 14.9575 12.0344 15.0504 12.5 15.0504C12.9656 15.0504 13.4266 14.9575 13.8559 14.7771C14.2852 14.5967 14.6741 14.3325 15 13.9999L19 9.99989C19.663 9.33685 20.0355 8.43757 20.0355 7.49989C20.0355 6.56221 19.663 5.66293 19 4.99989C18.337 4.33685 17.4377 3.96436 16.5 3.96436C15.5623 3.96436 14.663 4.33685 14 4.99989L13.5 5.49989"
                    stroke="#506BF0"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.0004 9.99997C13.6745 9.66737 13.2855 9.40315 12.8563 9.22276C12.427 9.04238 11.966 8.94946 11.5004 8.94946C11.0347 8.94946 10.5738 9.04238 10.1445 9.22276C9.71523 9.40315 9.32626 9.66737 9.00038 9.99997L5.00038 14C4.33734 14.663 3.96484 15.5623 3.96484 16.5C3.96484 17.4377 4.33734 18.3369 5.00038 19C5.66342 19.663 6.5627 20.0355 7.50038 20.0355C8.43806 20.0355 9.33734 19.663 10.0004 19L10.5004 18.5"
                    stroke="#506BF0"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1129_151">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        {trigger && (
          <Popup
            trigger={trigger}
            setTrigger={setTrigger}
            isSelected={isSelected}
            handleCheckboxChange={handleCheckboxChange}
            title={node.title}
            url={node.url}
          />
        )}
        {isExpanded &&
          node.children &&
          node.children.map((child) => (
            <TreeNode
              key={child.id}
              node={child}
              userData={userData}
              setUserData={setUserData}
              totalPageCount={totalPageCount}
            />
          ))}
      </li>
    </ul>
  );
};

export default TreeNode;
